/*
 * 機能別コンポーネント 明細集計パネル画面で使用するconst・interface・types
 * ・更新履歴
 *   2020/12/25 ファイル作成 小林
 *   2020/12/28 使用用途等コメント追加 小林
 */
/** 集計で表示する内容の文字列定数 */
export const SummaryViewType = {
  TOTAL: '合算',
  CONSUMPTIONTAXONLY: '消費税のみ',
  CONSUMPTIONTAXINCLUDED: '消費税込み',
  COSTRATE: '原価率',
  GROSSPROFITMARGIN: '粗利率'
  //...
};

/** 税率などの文字列定数 */
export const Tax = {
  CONSUMPTIONTAX10: 0.1
  //...
};

/** 集計に用いるテスト用仮データ */
export const MainData = [
  {value:30000},{value:40000}
  //...
];
/** 集計に用いるテスト用仮データ */
export const SubData = 10;
/** 集計に用いるテスト用仮プロパティ */
export const MainDataPropertyName = 'value';
/** 集計に用いるテスト用仮プロパティ */
export const SubDataPropertyName = '';
/** 集計コンポーネントに表示するテスト用仮ラベル */
export const LabelText = ['合計金額', '消費税額', '粗利率'];
/** 集計コンポーネントに表示するテスト用仮単位 */
export const UnitText = ['￥', '￥', '％'];
/** 集計コンポーネントに表示するテスト用単位の仮位置 */
export const UnitPosition = ['front', 'front', 'back'];
/** 集計コンポーネントに表示するテスト用仮表示タイプ */
export const ViewType = [SummaryViewType.TOTAL, SummaryViewType.CONSUMPTIONTAXONLY, SummaryViewType.GROSSPROFITMARGIN];
